import { webUtils } from './web-utils.js';

const BG_SIZES = [380, 768, 1024, 1536, 2048];

const coveringSize = (width) => BG_SIZES.find((size) => width <= size) || BG_SIZES[BG_SIZES.length - 1];

const backgroundAttr = (size, highPixelRatio) => {
    const next = highPixelRatio ? BG_SIZES[BG_SIZES.indexOf(size) + 1] : size;
    return next ? `${next}-bg` : 'full-bg';
};

const simpleBackgroundAttr = (width, highPixelRatio) => {
    if (width > 600) {
        return '2048-bg';
    }
    return highPixelRatio ? '1536-bg' : '1024-bg';
};

$(document).ready(function () {
    // img tags
    $('.srcset').each(function () {
        var $this = $(this);
        $this.attr('data-sizes', $this.data('fixed-sizes') ? $this.data('fixed-sizes') : $this.width() + 'px');
        $this.removeAttr('data-fixed-sizes');
    });

    const highPixelRatio = webUtils.highPixelRatio();

    $('.responsive-bg').each(function () {
        const $this = $(this);
        const url = $this.data(backgroundAttr(coveringSize($this.innerWidth()), highPixelRatio));

        if ($this.hasClass('no-lazy')) {
            $this.attr('style', 'background-image: url("' + url + '")');
        } else {
            $this.attr('data-src', url);
        }
    });

    $('.responsive-bg-simple').each(function () {
        const $this = $(this);
        $this.attr('data-src', $this.data(simpleBackgroundAttr($this.innerWidth(), highPixelRatio)));
    });
});
